import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import useNotification from 'containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';
import { Color } from '@teetsh/app/src/types/colors';
import { EleveGroup } from 'types/eleveGroups';
import { ELEVE_GROUPS_KEY } from './useEleveGroups';
import { TagColorWithIntensity } from '@teetsh/app/src/styles/userConstants';
import { EPHEMERAL_GROUPS_KEY } from 'queries/eleveGroups/useEphemeralEleveGroups';

interface UpdateEleveGroupParams {
  id: string;
  name: string;
  color?: Color | TagColorWithIntensity;
  elevesIds?: string[];
}

export function useUpdateEleveGroup() {
  const queryClient = useQueryClient();
  const { schoolyear, school } = useSchoolSchoolyear();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['eleve']);

  return useMutation({
    mutationFn: ({ id, name, color, elevesIds }: UpdateEleveGroupParams) =>
      request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/eleve-groups/${id}`,
        {
          method: 'PATCH',
          body: { name, color, elevesIds },
        },
      ).then(({ data }) => data as EleveGroup),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, ELEVE_GROUPS_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, EPHEMERAL_GROUPS_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('eleve:messages.updateGroupError'),
      });
    },
  });
}
